import { alpha } from '@mui/material'
import { colors } from './colors.theme'

const { green, red } = colors

const iconColors = Object.fromEntries(
  Object.entries(colors).map(([key, val]) => {
    return [
      [`&.${key}`],
      {
        color: val,
      },
    ]
  }),
)

export const svgIconTheme = {
  root: {
    '&.green-bg': {
      color: green,
      background: alpha(green, 0.3),
      borderRadius: '50%',
      padding: 2,
    },
    '&.red-bg': {
      color: red,
      background: alpha(red, 0.3),
      borderRadius: '50%',
      padding: 2,
    },
    '&.small': {
      fontSize: 20,
    },
    ...iconColors,
  },
}
